import * as React from 'react';

import { NEW_OBJECTS_KEYS, NEW_OBJECTS_NAMES, NEW_OBJECTS_SHORT_NAMES } from '../../interfaces/villages';
import { INewobjectCategoryForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/newobject_category/NewobjectCategoryForListPresenterSchema';
import { INewobjectCategorySetForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/newobject_category/NewobjectCategorySetForListPresenterSchema';
import { trackPriceOpened } from './tracking';
import { getPriceRange, getAreaFromBlock } from '../../utils';
import { Link } from '../Link';
import * as styles from './index.css';
import { UIText2 } from '@cian/ui-kit';

export interface IVillageObjectProps {
  object?: INewobjectCategoryForListPresenterSchema;
  objectType: keyof INewobjectCategorySetForListPresenterSchema;
  href: string | null;
  villageId: number;
  hidePrice?: boolean;
}

export const VillageObject = (props: IVillageObjectProps) => {
  const { object, objectType, villageId, href, hidePrice } = props;

  const info = React.useMemo(() => {
    if (!object) {
      return null;
    }

    const { areaMin, areaMax } = object;

    return (
      <>
        <span className={styles['short_name']}>{NEW_OBJECTS_SHORT_NAMES[objectType]}</span>
        <span className={styles['full_name']}>{NEW_OBJECTS_NAMES[objectType]}</span>
        <span> {getAreaFromBlock(areaMin as number, areaMax as number, objectType === NEW_OBJECTS_KEYS.LANDPLOT)}</span>
      </>
    );
  }, [object, objectType]);

  if (!object) {
    return null;
  }

  const { priceMin, priceMax } = object;

  return (
    <div className={styles['container']}>
      <UIText2 display="inline-block">
        <span className={styles['info']}>
          {href ? (
            <Link href={href} target="_blank" onClick={() => trackPriceOpened(objectType, villageId)}>
              {info}
            </Link>
          ) : (
            info
          )}
        </span>
        {!hidePrice && <div>{getPriceRange(String(priceMin), String(priceMax))}</div>}
      </UIText2>
    </div>
  );
};
